<template>
  <router-view/>
</template>

<style>

html {
  scroll-behavior: smooth;
}

body {
  background-color: #f8f9fa;
}
</style>
